import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../Styles/css/SpecialAlert.css';
import postponementImg from '../assets/postponement-album.jpg';

export default class SpecialAlert extends Component {

    _hideDate = new Date('2019-04-19');

    static propTypes = {
        onClose: PropTypes.func
    }

    state = {
        closing: false
    }

    render() {

        if (new Date() >= this._hideDate) {
            return null;
        }

        return (
            <div className={`modal ${this.state.closing ? 'closing' : ''}`}>
                <div className="overlay"></div>
                <div className={`modal-content ${this.state.closing ? 'closing' : ''}`}>
                    <div className="left">
                        <h2>Debut LP <span>Postponement</span> out April 19th</h2>
                        <a className="action-button" href="https://shop.flaural.co/product/pre-order-postponement-vinyl-lp">PRE-ORDER NOW</a>
                    </div>
                    <div><img src={postponementImg} /></div>
                    <a className="action-button mobile" href="https://shop.flaural.co/product/pre-order-postponement-vinyl-lp">PRE-ORDER NOW</a>
                    {/* <button className="action-button">PRE-ORDER NOW</button> */}
                    <button title="Close" className="close-modal" onClick={() => this.handleClose()}>
                        {/* <i className="fas fa-times"></i> */}
                        &times;
                    </button>
                </div>
            </div>
        )
    }

    handleClose() {

        this.setState({ closing: true });

        setTimeout(() => this.props.onClose(), 1000);
    }
}



// WEBPACK FOOTER //
// ./src/Components/SpecialAlert.js